<template>
    <div id="orderList">
        <!-- <van-nav-bar title="欠款列表" fixed placeholder left-arrow>
      <a @click="$router.back()" slot="left">
        <i class="iconfont iconfanhuianniu"></i>
      </a>
      <a @click="showSearch = !showSearch" slot="right">
        <i class="iconfont iconSearch"></i>
      </a>
    </van-nav-bar> -->
        <van-list v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" offset="100" @load="getList">
            <div class="body">
                <div v-for="(orderItems,index) in list" :key="index">
                    <div class="orderBody">
                        <div class="orderBody-body blod">
                            <div class="name">{{orderItems.orderName}}</div>
                            <div :class="orderItems.status == '3'?'success':'fail'">{{orderItems.settlementStatus?settlementStatusList[orderItems.settlementStatus-1]: payList[orderItems.status-1]}}</div>
                        </div>
                        <div class="orderBody-body">
                            <div class="name">租期：{{orderItems.startDate?orderItems.startDate.slice(0,10):''}} 到 {{orderItems.endDate?orderItems.endDate.slice(0,10):''}}</div>
                            <div v-if="orderItems.expireDays&&!orderItems.settlementStatus" class="money">{{orderItems.expireDays}}天</div>
                        </div>
                        <div class="orderBody-body">
                            合约：{{orderItems.contractNumber}} | {{orderItems.houseAddress}}
                            <span v-if="orderItems.roomNo">{{orderItems.roomNo}}房</span>
                        </div>
                        <div class="orderBody-body">租客：{{orderItems.customerName}} | <a onclick="window.event.cancelBubble=true" style="color:#fd7e2d;margin-left:5px" :href="'tel:'+orderItems.customerPhone">
                                    <i class="iconfont iconweibiaoti-" ></i>
                                </a>
                        </div>
                        <div class="orderBody-head">
                            <div>
                                <p class="name">账单金额</p>
                                <p class="text">￥{{orderItems.copeAmount}}</p>
                            </div>
                            <div class="line"></div>
                            <div>
                                <p class="name">已付金额</p>
                                <p class="text">￥{{orderItems.actualAmount}}</p>
                            </div>
                            <div class="line"></div>
                            <div>
                                <p class="name">账单日期</p>
                                <p class="text">{{orderItems.expireDate?orderItems.expireDate.slice(0,10):''}}</p>
                            </div>
                        </div>
                        <div :class="orderItems.detailShow?'':'border-b'" class="orderBody-body">
                            <div class="name">
                                <!-- <span v-if="orderItems.unpaidAmount/1<0">待收款金额</span> -->
                                <span>未支付金额</span>&emsp;
                                <span class="money">￥{{accSub(orderItems.copeAmount,orderItems.actualAmount)}}</span>
                            </div>
                            <div class="text" @click.stop="orderItems.detailShow = !orderItems.detailShow">
                                费用明细
                                <span>
                                    <i v-if="!orderItems.detailShow" class="iconfont iconxiala"></i>
                                    <i v-if="orderItems.detailShow" class="iconfont iconxiangshang"></i>
                                </span>
                            </div>
                        </div>
                        <div class="details" v-if="orderItems.detailShow">
                            <div v-for="(detail,index) in orderItems.orderItemList" :key="index">
                                <div class="name">{{detail.matterName}}</div>
                                <div>￥{{detail.copeAmount}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
        <div style="height:1.2rem"></div>
        <div class="btn">
            <van-button class="font1" type="primary" block @click="showSearch = !showSearch">筛选</van-button>
        </div>
        <transition name="van-fade">
            <div v-show="showSearch" class="search">
                <div class="field">
                    <div class="searchT">合约编码</div>
                    <van-field left-icon="label-o" maxlength="20" v-model="listQuery.numberInfo" placeholder="合约编码" />
                </div>
                <div class="field">
                    <div class="searchT">租客</div>
                    <van-field left-icon="user-o" maxlength="20" v-model="listQuery.customerInfo" placeholder="姓名/手机号" />
                </div>
                <div class="field">
                    <div class="searchT">房源</div>
                    <van-field left-icon="wap-home-o" maxlength="20" v-model="listQuery.houseInfo" placeholder="小区/房源编码/地址" />
                </div>
                <!-- <div class="field field1">
          <div class="searchT">预定方式</div>
          <div class="flex">
            <div :class="{'active':listQuery.rentType == ''}" @click="listQuery.rentType = ''">全部</div>
            <div :class="{'active':listQuery.rentType == 5}" @click="listQuery.rentType = 5">整租</div>
            <div :class="{'active':listQuery.rentType == 6}" @click="listQuery.rentType = 6">合租</div>
          </div>
        </div>-->
                <div class="field field1">
                    <div class="searchT">账单状态</div>
                    <div class="flex">
                        <div :class="{'active':listQuery.status == ''}" @click="listQuery.status = ''">全部</div>
                        <div :class="{'active':listQuery.status == 1}" @click="listQuery.status = 1">未支付</div>
                        <div :class="{'active':listQuery.status == 2}" @click="listQuery.status = 2">部分支付</div>
                        <!-- <div :class="{'active':listQuery.status == 3}" @click="listQuery.status = 3">已支付</div> -->
                    </div>
                </div>
                <div style="height:1.2rem;"></div>
                <div class="bottom">
                    <van-button class="font5" type="default" @click="resetSearch">重置</van-button>
                    <van-button class="font5" type="primary" @click="searchConfirm">确定</van-button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { requestOrderList } from "@/api";
import { accSub } from "@/utils";
export default {
    name: "orderList",
    data() {
        return {
            listQuery: {
                numberInfo: "", //编码信息
                customerInfo: "", //租客信息
                houseInfo: "", //房源信息
                status: "", //支付状态
                pageNumber: 1,
                pageSize: 10,
            },
            loading: false,
            finished: false,
            showSearch: false,
            list: [],
        };
    },
    computed: {
        ...mapState([
            "idTypeList",
            "destineList",
            "payList",
            "contractList",
            "customerList",
            "settlementStatusList",
        ]),
    },
    activated() {
        this.listQuery.pageNumber = 1;
        this.finished = false;
        this.list = [];
        this.getList();
    },
    created() {},
    mounted() {},
    methods: {
        getList() {
            this.loading = true;
            requestOrderList(this.listQuery)
                .then((res) => {
                    if (this.finished) return;
                    res.data.records.forEach((d) => {
                        d.detailShow = false;
                    });
                    this.list = [...this.list, ...res.data.records];
                    let prePage = accSub(res.data.pages, 1);
                    this.loading = false;
                    this.listQuery.pageNumber++;
                    if (
                        (res.data.pages == res.data.current &&
                            res.data.records.length ==
                                accSub(res.data.total, prePage * 10)) ||
                        !res.data.records.length
                    ) {
                        this.finished = true;
                    }
                })
                .catch((err) => {
                    this.finished = true;
                    this.loading = false;
                });
        },
        resetSearch() {
            this.listQuery = {
                numberInfo: "", //编码信息
                customerInfo: "", //租客信息
                houseInfo: "", //房源信息
                rentType: "", //预定方式
                status: "", //合约状态
            };
            this.list = [];
            this.finished = false;
            this.showSearch = false;
            this.getList();
        },
        searchConfirm() {
            this.listQuery.pageNumber = 1;
            this.showSearch = false;
            this.finished = false;
            this.list = [];
            this.getList();
        },
        accSub(num1, num2) {
            return accSub(num1, num2);
        },
    },
    watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
.body {
    .orderBody {
        padding: 0 0.2rem;
        // border: 2px dashed #dadada;
        margin: 0.4rem 0;
        border-radius: 0.2rem;
        background-color: #fff;
        .orderBody-head {
            padding: 0.2rem;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid $border-color;
            .line {
                width: 1px;
                height: 0.8rem;
                transform: translateY(0.05rem);
                background: #dadada;
            }
            .name {
            }
            .text {
                font-weight: bold;
                // color: $font-deep-gray;
            }
            p {
                padding: 0.1rem 0;
            }
        }
        .orderBody-body {
            display: flex;
            padding: 0.3rem 0;
            border-bottom: 1px solid $border-color;
            .name {
                flex: 1;
                text-align: left;
            }
            .money {
                color: $fail-color;
            }
            .success {
                color: $success-color;
            }
            .fail {
                color: $fail-color;
            }
            .pay {
                color: #fff;
                padding: 0.1rem 0.2rem;
                background: #fd7e2d;
                border-radius: 0.1rem;
            }
            .text {
                span {
                    display: inline-block;
                    width: 0.5rem;
                }
                i {
                    font-size: 0.3rem;
                }
            }
        }
        .border-b {
            border: none !important;
        }
        .details {
            color: $font-deep-gray;
            padding: 0.2rem 0;
            > div {
                display: flex;
                padding: 0.1rem;
                .name {
                    flex: 1;
                    text-align: left;
                }
            }
        }
        .blod {
            font-weight: bold;
        }
    }
}
.search {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background-color: #fff;
    z-index: 99;
    overflow: scroll;
    // padding-top: 0.4rem;
    .field {
        padding: 0 0.7rem;
        .searchT {
            text-align: left;
            font-size: 0.41rem;
            font-weight: 600;
            color: #666666;
            margin: 0.4rem 0;
            // padding-left: 0.4rem;
        }
        /deep/.van-cell {
            border: 1px solid $border-color;
        }
        .flex {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            padding-left: 0.35rem;
            > div {
                margin: 0.2rem 0.35rem;
                width: 2.4rem;
                height: 0.8rem;
                line-height: 0.8rem;
                border: 1px solid $border-color;
                &.active {
                    border: 1px solid $theme-color;
                    color: $theme-color;
                }
                input {
                    width: 100%;
                    height: 95%;
                    border: none;
                    text-align: center;
                }
            }
            .range {
                position: relative;
                overflow: inherit;
                &::after {
                    content: "~";
                    position: absolute;
                    right: -0.5rem;
                    top: 0;
                }
            }
        }
    }
    .field1 {
        padding: 0;
        .searchT {
            padding: 0 0.7rem;
            margin: 0.3rem 0;
        }
    }
    .bottom {
        position: fixed;
        bottom: 0;
        display: flex;
        width: 100%;
        /deep/.van-button--primary {
            margin-left: -1px;
            border: none;
            border-radius: 0;
        }
        .font5 {
            width: 51%;
        }
    }
}
.btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
        margin-left: -1px;
        border: none;
        border-radius: 0;
        flex: 1;
        &:not(:last-child)::after {
            height: 50%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-right: 0.02667rem solid #ebedf0;
            z-index: 99;
        }
    }
    .font4 {
        width: 2.4rem;
    }
    .font3 {
        width: 1.8rem;
    }
    .font5 {
        width: 51%;
    }
    .font1 {
        width: 100%;
        margin-left: 0;
    }
}
</style>
